export default "__VITE_ASSET__BsvyaYiZ__"